import { useEffect, useMemo, useRef, useState } from "react"
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";
import { useLocation } from "react-router-dom";

export const useProjectReport = () => {
    const [rowData, setRowData] = useState([]);
    const tagRef = useRef(null);
    const location = useLocation().state;

    useEffect(() => {
        getProjectReport();
    }, []);

    const columnDefs = [
        { field: 'project_module', headerName: ' Name', width: '200px' },
        { field: 'total_features', headerName: 'Issue Count', width: '150px' },
        { field: 'backlog_features', headerName: 'To Do', width: '150px' },
        { field: 'in_progress_features', headerName: 'In Progress', width: '150px' },
        { field: 'done_features', headerName: 'Completed', width: '150px' },
        {
            field: 'Overral progress', headerName: 'Overall Progress',
            cellRenderer: (params) => {
                const rowData = params.data;
                // const backlog = rowData.backlog_features;
                // const inProgress = rowData.in_progress_features;
                // const done = rowData.done_features;
                const complatePr = rowData.completed_issues_percentage

                return (
                    <div style={{ width: '100%', height: '10px', marginTop: '5px' }}>
                        <div style={{ display: 'flex' }}>
                            <h2 style={{ fontSize: '10px', width: '100%', textAlign: 'end', justifyContent: 'end' }}>{complatePr}</h2>
                        </div>

                        <div>
                            <div className="task-status" style={{ height: "10px", width: "100%" }}>
                                {/* <span className='task-backlog' style={{ width: `${backlogPr}` }}></span>
                                <span className='task-complate' style={{ width: `${progressPr}` }}></span> */}
                                <span className='task-complate' style={{ width: `${complatePr}` }}></span>
                            </div>
                        </div>
                    </div>
                );
            }
        },
    ];

    // get project report data
    const getProjectReport = async () => {        
        try {
            const payload = {
                project_id: location.project_id,
                hierarchyLevel: 1,
            }
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTMODULELIST'), payload)
            const data = res?.body?.data?.project_Summary
            if (!_.isEmpty(data)) {
                const summaryData = data.map((ele) => ({
                    project_module: ele?.project_module || '-',
                    total_features: ele?.total_features,
                    backlog_features: ele?.backlog_features,
                    in_progress_features: ele?.in_progress_features,
                    done_features: ele?.done_features,
                    completed_issues_percentage: ele?.completed_issues_percentage
                }))

                setRowData(summaryData)
            }
        }
        catch (error) {
            console.error('Error :', error);
        }
    }
    return useMemo(() => ({
        tagRef, columnDefs, rowData
    }), [tagRef, columnDefs, rowData])
}